import useStores from '@stores/useStores';
import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { AuthorizationScheme } from '@stores/security';
import Backdrop from '@ui-library/modal/skeleton';
import Password from './password';
import Otp from './otp';

const Container = styled.div`
  position: fixed;
  z-index: 100000;
`;

const Security = () => {
  const {
    securityStore: { submit, cancel, error, loading, scheme },
  } = useStores();

  const getComponent = () => {
    if (scheme === AuthorizationScheme.SmsOtp) {
      return <Otp submit={submit} cancel={cancel} error={error} loading={loading} />;
    }
    if (scheme === AuthorizationScheme.Password) {
      return <Password submit={submit} cancel={cancel} error={error} loading={loading} />;
    }
    return null;
  };

  if (!scheme) {
    return null;
  }

  return (
    <Container>
      <Backdrop show modalClosed={cancel}>
        {getComponent()}
      </Backdrop>
    </Container>
  );
};

export default observer(Security);
